var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientListFill0Wght400Grad0Opsz48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M640 653q-51 0-84.5-33.5T522 535q0-51 33.5-84.5T640 417q51 0 84.5 33.5T758 535q0 51-33.5 84.5T640 653ZM400 896v-66q0-18.864 9-35.932T433 770q45-32 98.5-47.5T640 707q55 0 108 17t99 46q14 10 23.5 25.5T880 830v66H400Zm55-71v11h370v-11q-39-26-90-42t-95-16q-44 0-95.5 16T455 825Zm185-232q26 0 42-16t16-42q0-26-16-42t-42-16q-26 0-42 16t-16 42q0 26 16 42t42 16Zm0-58Zm0 301ZM120 646v-60h306v60H120Zm0-330v-60h473v60H120Zm349 165H120v-60h380q-11 13-18.727 27.921Q473.545 463.841 469 481Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientListFill0Wght400Grad0Opsz48);
export default __webpack_public_path__ + "static/media/patient_list_FILL0_wght400_GRAD0_opsz48.00ded63f72600282bc560565c93802cd.svg";
export { ForwardRef as ReactComponent };